(() => {
  const BUTTON_ID = "searchbar-image-search";
  const backdrop = document.getElementById("ryzo-consent-backdrop");
  const btnCancel = document.getElementById("ryzo-consent-cancel");
  const btnContinue = document.getElementById("ryzo-consent-continue");

  let pendingBtn = null;
  let handlerAttached = false;

  function openModal(btn){
    pendingBtn = btn;
    backdrop.style.display = "flex";
    backdrop.setAttribute("aria-hidden","false");
    btnContinue && btnContinue.focus();
  }

  function closeModal(){
    backdrop.style.display = "none";
    backdrop.setAttribute("aria-hidden","true");
    pendingBtn = null;
  }

  backdrop.addEventListener("click", (e) => { if (e.target === backdrop) closeModal(); }, { passive: true });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && backdrop.style.display === "flex") closeModal();
  });

  btnCancel.addEventListener("click", closeModal);

  btnContinue.addEventListener("click", () => {
    const btn = pendingBtn;
    closeModal();
    if (!btn) return;
    /* Zapomni si privolitev — modal se ne prikazuje ob vsakem kliku znova */
    try { localStorage.setItem("ryzoConsentOk", "1"); } catch(_){}
    btn.dataset.ryzoConsentOk = "1";
    btn.click();
    setTimeout(() => { try { delete btn.dataset.ryzoConsentOk; } catch(_){} }, 0);
  });

  function attachInterceptors(){
    if (handlerAttached) return;
    handlerAttached = true;

    const intercept = (e) => {
      const btn = e.target && e.target.closest ? e.target.closest("#" + BUTTON_ID) : null;
      if (!btn) return;
      if (btn.dataset.ryzoConsentOk === "1") return;
      /* Privolitev je bila že dana — spusti klik naravnost v Ryzo */
      try { if (localStorage.getItem("ryzoConsentOk") === "1") return; } catch(_){}

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      openModal(btn);
    };

    document.addEventListener("pointerdown", intercept, true);
    document.addEventListener("click", intercept, true);
  }

  function waitForRyzoButton(){
    const existing = document.getElementById(BUTTON_ID);
    if (existing) { attachInterceptors(); return; }

    const obs = new MutationObserver(() => {
      const btn = document.getElementById(BUTTON_ID);
      if (btn) {
        obs.disconnect();
        attachInterceptors();
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => { try { obs.disconnect(); } catch(_){} }, 15000);
  }

  const start = () => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(waitForRyzoButton, { timeout: 1200 });
    } else {
      setTimeout(waitForRyzoButton, 0);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
